import React from 'react';
import FormField from '../FormField';
import { formValues } from 'redux-form';
import CurrencySelector from '../CurrencySelector';
import classnames from 'classnames';
import styles from './OpenHouseFieldset.scss';

const normInt = value => {
  const parsed = parseInt(value);
  return (parsed || parsed === 0) ? parsed : '';
};
const normFloat = value => parseFloat(value) || '';

const OpenHouseFieldset = formValues({
  currency: 'currency',
})(({ formErrors, currency, currencies }) => {
  return (
    <div className={classnames('row', styles.propertyInformation)}>
      <div className="col-md-12">
        <div className={classnames('card-header', 'mb-3', 'mx-0')}>
          <h4>Property Information</h4>
        </div>
      </div>
      <div className="col-md-4">
        <FormField
          label="Beds"
          error={formErrors.getIn(['open_house', 'beds'])}
          name="open_house.beds"
          component="input"
          required
          type="text"
          normalize={normInt}
          className="form-control"
          placeholder="Enter the number of bedrooms"
        />
      </div>
      <div className="col-md-4">
        <FormField
          label="Baths"
          error={formErrors.getIn(['open_house', 'baths'])}
          name="open_house.baths"
          component="input"
          required
          type="number"
          normalize={normFloat}
          className="form-control"
          placeholder="Enter the number of bathrooms"
        />
      </div>
      <div className="col-md-4">
        <FormField
          label="Cars"
          error={formErrors.getIn(['open_house', 'cars'])}
          name="open_house.cars"
          component="input"
          required
          type="text"
          normalize={normInt}
          className="form-control"
          placeholder="Enter the number of car parking places"
        />
      </div>
      <div className="col-md-4">
        <FormField
          label="Square footage"
          error={formErrors.getIn(['open_house', 'square_feet'])}
          name="open_house.square_feet"
          component="input"
          required
          type="text"
          normalize={normInt}
          className="form-control"
          placeholder="Enter the size of the property"
        />
      </div>
      <div className="col-md-4">
        <FormField
          label="Price"
          error={formErrors.getIn(['open_house', 'price'])}
          name="open_house.price"
          normalize={normInt}
          required
          component="input"
          type="text"
          className="form-control"
          placeholder="Enter the price the house is selling for"
        />
      </div>
      <div className="col-md-4">
        <CurrencySelector
          label="Currency"
          formErrors={formErrors}
          currencies={currencies}
          currency={currency}
          error={formErrors.getIn(['open_house', 'currency'])}
          name="open_house.currency"
        />
      </div>
    </div>
  );
});

export default OpenHouseFieldset;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/fieldsets/OpenHouseFieldset.jsx